<template>
  <div class="home">
    <div class="banner">
      <img alt="Vue logo" src="/logo.png" style="width: 64px; height: 64px" />
      <h3 style="margin-top: 1rem">Welcome to Your Vue.js App</h3>
    </div>

    <br />

    <h2># Trend 组件</h2>

    <a-divider>正常</a-divider>

    <a-card>
      <trend flag="up" style="margin-right: 16px;">
        <span slot="term">工资</span>
        5%
      </trend>
      <trend flag="up" style="margin-right: 16px;">
        <span slot="term">工作量</span>
        50%
      </trend>
      <trend flag="down">
        <span slot="term">身体状态</span>
        50%
      </trend>
    </a-card>

    <a-divider>颜色反转</a-divider>

    <a-card style="margin-bottom: 3rem">
      <trend :reverse-color="true" flag="up" style="margin-right: 16px;">
        <span slot="term">工资</span>
        5%
      </trend>
      <trend :reverse-color="true" flag="down" style="margin-right: 16px;">
        <span slot="term">工作量</span>
        50%
      </trend>
    </a-card>

    <h2># AvatarList 组件</h2>

    <a-divider>AvatarList</a-divider>
    <a-card style="margin-bottom: 3rem">
      <avatar-list :max-length="3">
        <avatar-list-item src="https://gw.alipayobjects.com/zos/rmsportal/zOsKZmFRdUtvpqCImOVY.png" tips="Jake" />
        <avatar-list-item src="https://gw.alipayobjects.com/zos/rmsportal/sfjbOqnsXXJgNCjCzDBL.png" tips="Andy" />
        <avatar-list-item src="https://gw.alipayobjects.com/zos/rmsportal/kZzEzemZyKLKFsojXItE.png" tips="Niko" />
        <avatar-list-item src="https://gw.alipayobjects.com/zos/rmsportal/kZzEzemZyKLKFsojXItE.png" tips="Niko" />
        <avatar-list-item src="https://gw.alipayobjects.com/zos/rmsportal/kZzEzemZyKLKFsojXItE.png" tips="Niko" />
        <avatar-list-item src="https://gw.alipayobjects.com/zos/rmsportal/kZzEzemZyKLKFsojXItE.png" tips="Niko" />
        <avatar-list-item src="https://gw.alipayobjects.com/zos/rmsportal/kZzEzemZyKLKFsojXItE.png" tips="Niko" />
      </avatar-list>

      <a-divider style="margin: 0 16px" type="vertical" />

      <avatar-list size="mini">
        <avatar-list-item src="https://gw.alipayobjects.com/zos/rmsportal/zOsKZmFRdUtvpqCImOVY.png" tips="Jake" />
        <avatar-list-item src="https://gw.alipayobjects.com/zos/rmsportal/sfjbOqnsXXJgNCjCzDBL.png" tips="Andy" />
        <avatar-list-item src="https://gw.alipayobjects.com/zos/rmsportal/kZzEzemZyKLKFsojXItE.png" tips="Niko" />
      </avatar-list>
    </a-card>

    <h2># CountDown 组件</h2>

    <a-divider>CountDown</a-divider>
    <a-card style="margin-bottom: 3rem">
      <count-down :on-end="onEndHandle" :target="new Date().getTime() + 3000000" style="font-size: 2rem"></count-down>

      <a-divider style="margin: 0 16px" type="vertical" />

      <count-down :on-end="onEndHandle2" :target="new Date().getTime() + 10000" style="font-size: 2rem"></count-down>
    </a-card>

    <h2># Ellipsis 组件</h2>

    <a-divider>Ellipsis</a-divider>
    <a-card style="margin-bottom: 3rem">
      <ellipsis :length="100" tooltip>
        There were injuries alleged in three cases in 2015, and a
        fourth incident in September, according to the safety recall report. After meeting with US regulators in October, the firm decided to issue a voluntary recall.
      </ellipsis>
    </a-card>

    <h2># NumberInfo 组件</h2>

    <a-divider>NumberInfo</a-divider>
    <a-card>
      <number-info :sub-title="() => { return 'Visits this week' }" :sub-total="17.1" :total="12321" status="up"></number-info>
    </a-card>
  </div>
</template>

<script>
  // @ is an alias to /src

  import Trend from '@/components/Trend'
  import AvatarList from '@/components/AvatarList'
  import CountDown from '@/components/CountDown/CountDown'
  import Ellipsis from '@/components/Ellipsis'
  import NumberInfo from '@/components/NumberInfo'

  const AvatarListItem = AvatarList.AvatarItem

  export default {
    name: 'Home',
    components: {
      NumberInfo,
      Ellipsis,
      CountDown,
      Trend,
      AvatarList,
      AvatarListItem
    },
    data () {
      return {
        targetTime: new Date().getTime() + 3900000
      }
    },
    methods: {
      onEndHandle () {
        this.$message.success('CountDown callback!!!')
      },
      onEndHandle2 () {
        this.$notification.open({
          message: 'Notification Title',
          description: 'This is the content of the notification. This is the content of the notification. This is the content of the notification.',
        });
      }
    }
  }
</script>

<style scoped>

  .home {
    width: 900px;
    margin: 0 auto;
    padding: 25px 0;
  }
  .home > .banner {
    text-align: center;
    padding: 25px 0;
    margin: 25px 0;
  }

</style>
